// generated by genversion
export var version = '3.8.21';
//# sourceMappingURL=version.js.map